// SOL Kids — Spring Summer '26 collection data
// Extracted from the official lookbook PDF.
// Each entry has: slug, name, personality, tagline (3 lines), audience, dimensions, colors

export const COLLECTIONS = [
  {
    slug: "hola",
    name: "Hola",
    tagline: ["Waves at everyone from behind cool shades.", "New park, same confidence.", "Sun's Out = Friends Out"],
    audience: "For friendly little explorers",
    dims: { width: 44, bridge: 15, arm: 114 },
    age: "4-7",
    colors: ["vanilla","peach","tangerine","minty","grape","sunshine","blueberry","bubbles","ninja","cherry cola","black currant"],
    accent: "var(--sage)",
    personality: "friendly-explorers",
    featured: true,
  },
  {
    slug: "coco",
    name: "CoCo",
    tagline: ["Smudged lenses, sandy hands.", "Wears them through all the mess.", "Play doesn't pause for clean-ups."],
    audience: "For messy adventurers",
    dims: { width: 41, bridge: 17, arm: 117 },
    age: "2-5",
    colors: ["vanilla","tangerine","sky","minty","grape","indigo","indigo dark","ninja","black currant","diet coke","cherry cola"],
    accent: "var(--sun)",
    personality: "high-energy-kids",
    featured: true,
  },
  {
    slug: "mimi",
    name: "MiMi",
    tagline: ["Peeks from behind slightly oversized shades.","Watches, then joins in.","Slow start, strong finish."],
    audience: "For quiet observers",
    dims: { width: 44, bridge: 15, arm: 115 },
    age: "3-6",
    colors: ["sunshine","tangerine","ketchup","bubbles","turtle","ninja"],
    accent: "var(--coral)",
    personality: "dreamy-wanderers",
  },
  {
    slug: "bebe",
    name: "Bebe",
    tagline: ["Tiny face, big sunglasses.","Keeps pushing them back up.","Still refuses to take them off."],
    audience: "For little bosses",
    dims: { width: 45, bridge: 15, arm: 118 },
    age: "2-4",
    colors: ["peach","candy floss","lily","tangerine","diet coke","cherry cola","goose","indigo","bubbles","black currant"],
    accent: "var(--lavender)",
    personality: "tiny-trendsetters",
    featured: true,
  },
  {
    slug: "vamos",
    name: "Vamos",
    tagline: ["Sunglasses on before stepping out.","Door opens, gone.","No time to wait."],
    audience: "For always-ready explorers",
    dims: { width: 49, bridge: 16, arm: 122 },
    age: "5-9",
    colors: ["sunshine","grape","lemonade","diet coke","tangerine"],
    accent: "var(--sky)",
    personality: "non-stop-runners",
  },
  {
    slug: "brio",
    name: "Brío",
    tagline: ["Wears them like they were made for it.","No adjusting, no fuss.","Just walks out owning the sun."],
    audience: "For natural-born cool",
    dims: { width: 42, bridge: 16, arm: 135 },
    age: "6-10",
    colors: ["vanilla","tangerine","violet","sky","grape","ninja","citrus"],
    accent: "var(--ink)",
    personality: "tiny-trendsetters",
  },
  {
    slug: "sol",
    name: "Sol",
    tagline: ["Shades on, face to the sun.","Squints less, plays more.","Golden hour all day."],
    audience: "For sunshine chasers",
    dims: { width: 44, bridge: 19, arm: 139 },
    age: "5-9",
    colors: ["sky","violet","sage","minty","tangerine","ninja"],
    accent: "var(--sun)",
    personality: "sunshine-chasers",
    featured: true,
  },
  {
    slug: "bono",
    name: "Bono",
    tagline: ["Shares snacks, shares toys, shares space.","Shades passed around, then back again.","Fun is better together."],
    audience: "For little sharers",
    dims: { width: 49, bridge: 14, arm: 122 },
    age: "5-8",
    colors: ["grape","sky","tangerine","bubble gum","lily","bubbles","black currant","diet coke","cherry cola","rose","cherry","goose","ninja"],
    accent: "var(--sky)",
    personality: "friendly-explorers",
  },
  {
    slug: "rio",
    name: "Rio",
    tagline: ["Shades on, already running.","They somehow stay on through all that speed.","Blink and it's gone past you."],
    audience: "For non-stop runners",
    dims: { width: 49, bridge: 17, arm: 131 },
    age: "6-10",
    colors: ["candy floss","blossom","lily","bubble gum","snorlax","ice lolly","peach","diet coke","cherry cola","oreo","goose","ninja"],
    accent: "var(--coral)",
    personality: "non-stop-runners",
    featured: true,
  },
  {
    slug: "chica",
    name: "Chica",
    tagline: ["Picks the sunglasses first, then the game.","Wears them like a little boss.","Everything follows."],
    audience: "For tiny trendsetters",
    dims: { width: 48, bridge: 17, arm: 130 },
    age: "5-9",
    colors: ["blossom","lily","black currant","diet coke","cherry cola","goose"],
    accent: "var(--lavender)",
    personality: "tiny-trendsetters",
  },
  {
    slug: "lolo",
    name: "Lolo",
    tagline: ["Tilted sunglasses, big laugh.","Slides, falls, rolls — still on.","That's part of the fun."],
    audience: "For tiny trendsetters",
    dims: { width: 46, bridge: 16, arm: 122 },
    age: "4-8",
    colors: ["candy floss","bubble gum","blossom","ice lolly","snorlax","blueberry","goose","ninja","black currant","diet coke","cherry cola"],
    accent: "var(--coral)",
    personality: "tiny-trendsetters",
  },
  {
    slug: "viva",
    name: "Viva",
    tagline: ["Shades bouncing, energy flying.","Jump, run, spin — still holding on.","Nothing slows this down."],
    audience: "For high-energy kids",
    dims: { width: 41, bridge: 23, arm: 126 },
    age: "4-8",
    colors: ["lily","candy floss","bubble gum","cherry","diet coke","cherry cola","snorlax","ice lolly","black currant","goose","ninja"],
    accent: "var(--sun)",
    personality: "high-energy-kids",
  },
  {
    slug: "tico",
    name: "Tico",
    tagline: ["Fast hands, quicker ideas.","Climbs, jumps, tries first.","Figures it out mid-air."],
    audience: "For fearless tryers",
    dims: { width: 46, bridge: 17, arm: 135 },
    age: "6-10",
    colors: ["candy floss","lily","violet","citrus","orange juice","cherry cola","kiwi","sky"],
    accent: "var(--sage)",
    personality: "fearless-tryers",
  },
  {
    slug: "luna",
    name: "Luna",
    tagline: ["Looks at the sky through tinted lenses.","Clouds, light, little daydreams.","Everything feels softer here."],
    audience: "For dreamy wanderers",
    dims: { width: 46, bridge: 17, arm: 128 },
    age: "5-9",
    colors: ["spongebob","splash","honey bee","candy floss","bubble gum","diet coke","ninja"],
    accent: "var(--sky)",
    personality: "dreamy-wanderers",
    featured: true,
  },
  {
    slug: "zaza",
    name: "Zaza",
    tagline: ["A little extra, always.","Louder laugh, brighter picks.","Spots this one in a crowd."],
    audience: "For bold personalities",
    dims: { width: 45, bridge: 18, arm: 126 },
    age: "5-9",
    colors: ["blossom","grape","fanta","bubbles","ice lolly","black currant","diet coke","cherry cola","raspberry","goose","ninja"],
    accent: "var(--coral)",
    personality: "high-energy-kids",
  },
  {
    slug: "neo",
    name: "Neo",
    tagline: ["Always one step ahead of the game.","Makes up new rules halfway through.","Turns every corner into an adventure."],
    audience: "For little originals",
    dims: { width: 43, bridge: 19, arm: 124 },
    age: "5-9",
    colors: ["vanilla","grape","lily","black currant","ice lolly","bubble gum","goose","diet coke","cherry cola","ninja"],
    accent: "var(--lavender)",
    personality: "fearless-tryers",
  },
  {
    slug: "rosa",
    name: "Rosa",
    tagline: ["Matches the sunglasses with the outfit.","Checks, twirls, approves.","Looking good is part of play."],
    audience: "For style lovers",
    dims: { width: 50, bridge: 18, arm: 133 },
    age: "6-10",
    colors: ["vanilla","violet","bubbles","black currant","diet coke","cherry cola","goose","ninja"],
    accent: "var(--lavender)",
    personality: "tiny-trendsetters",
  },
  {
    slug: "pico",
    name: "Pico",
    tagline: ["Always peeking over, under, through.","Curious about everything.","Nothing goes unnoticed."],
    audience: "For little explorers",
    dims: { width: 55, bridge: 15, arm: 117 },
    age: "7-10",
    colors: ["minty","sky","violet"],
    accent: "var(--sage)",
    personality: "friendly-explorers",
  },
  {
    slug: "nino",
    name: "Nino",
    tagline: ["Simple, easy, goes with everything.","Wears them without thinking twice.","Out the door in seconds."],
    audience: "For everyday players",
    dims: { width: 52, bridge: 14, arm: 107 },
    age: "6-10",
    colors: ["bubble gum","sunshine","minty","violet","cherry","goose","bubbles","diet coke","ninja"],
    accent: "var(--sky)",
    personality: "friendly-explorers",
  },
  {
    slug: "kiko",
    name: "Kiko",
    tagline: ["Always mid-climb, mid-jump, mid-something.","Shades holding on through it all.","No such thing as 'sit still'."],
    audience: "For active climbers",
    dims: { width: 53, bridge: 17, arm: 120 },
    age: "7-10",
    colors: ["tangerine","honey bee","cherry cola","vanilla","indigo","fanta","lemonade"],
    accent: "var(--coral)",
    personality: "fearless-tryers",
  },
  {
    slug: "nube",
    name: "Nube",
    tagline: ["Soft light, slow steps, easy days.","Shades stay on, even when lying back.","Just watching the sky."],
    audience: "For easy-going dreamers",
    dims: { width: 52, bridge: 16, arm: 115 },
    age: "6-10",
    colors: ["vanilla","diet coke","sunshine","bubbles","cherry cola","black currant"],
    accent: "var(--sky)",
    personality: "dreamy-wanderers",
  },
  {
    slug: "rumba",
    name: "Rumba",
    tagline: ["Music on, body moving.","Shades stay through every spin.","Can't stand still for long."],
    audience: "For little dancers",
    dims: { width: 54, bridge: 15, arm: 115 },
    age: "7-10",
    colors: ["bubbles","indigo","black currant","goose","diet coke","cherry cola","ninja","bubble gum"],
    accent: "var(--lavender)",
    personality: "high-energy-kids",
  },
  {
    slug: "ola",
    name: "Ola",
    tagline: ["Chasing water, splashing through.","Shades on at the edge of it all.","Comes back wetter, happier."],
    audience: "For splash lovers",
    dims: { width: 51, bridge: 13, arm: 121 },
    age: "5-9",
    colors: ["ice lolly","bubbles","black currant","diet coke","cherry cola","goose","ninja"],
    accent: "var(--sky)",
    personality: "friendly-explorers",
  },
];

export const findCollection = (slug) => COLLECTIONS.find((c) => c.slug === slug);

export const collectionsByPersonality = (personalitySlug) =>
  COLLECTIONS.filter((c) => c.personality === personalitySlug);

export const FEATURED = COLLECTIONS.filter((c) => c.featured);

export const PRICE = "₹ 999"; // single uniform price — shipping charges extra, as applicable
